import { Insurance, InsuranceRaw } from "frontend/interfaces/insurance";

export function parseInsurance(insurance: InsuranceRaw): Insurance {
  return { ...insurance };
}
